import { render } from "./Chats.vue?vue&type=template&id=fd6ae83e&scoped=true"
import script from "./Chats.vue?vue&type=script&lang=js"
export * from "./Chats.vue?vue&type=script&lang=js"

import "./Chats.vue?vue&type=style&index=0&id=fd6ae83e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd6ae83e"]])

export default __exports__